






import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class NameIcon extends Vue {
  @Prop({ type: String }) readonly name!: string;
  @Prop({ type: String, default: '32px' }) width?: string;
  @Prop({ type: String, default: '32px' }) height?: string;

  get initials() {
    const name = this.name.match(/\b(\w)/g);

    return name ? [name.shift(), name.pop()].join('') : '--';
  }
}
